export const asiatique = {
  themeOptionFactories: null,
  ignoreAppThemeFactory: false,
  routes: {
    mobile: [],
    "kiosk-v": [],
    "kiosk-h": [],
  },
}
